export const fetchFilteredItems = async (searchFields, searchTerm, server) => {
    const filter = searchFields.map((field) => [
        {
            field: field,
            op: ':',
            value: searchTerm
        }
    ]);

    try {
        return await server.getAllFiltered(filter);
    } catch (error) {
        return { error: error };
    }
};

export const fetchItemsByIDs = async (ids, server) => {
    try {
        return await server.getAllFiltered([
            [{ field: 'id', op: '=', value: ids }]
        ]);
    } catch (error) {
        return { error: error };
    }
};
export const fetchItemsByField = async (field, value, server) => {
    try {
        return await server.getAllFiltered([
            [{ field: field, op: '@', value: value }]
        ]);
    } catch (error) {
        return { error: error };
    }
};

export const fetchFirstItems = async (limit, server) => {
    try {
        return await server.search(limit, [], [], {});
    } catch (error) {
        return { error: error };
    }
};
